module.exports = __webpack_public_path__ + "static/media/biaacc4.a39bdc03.jpg";